import { createTheme } from '@mui/material/styles';
import { PRIMARY_MAIN, SECONDARY_MAIN } from './utilities/constants';

const FOCUS_RING = '0 0 0 3px rgba(95, 91, 205, 0.55)';

const theme = createTheme({
  palette: {
    primary: { main: PRIMARY_MAIN },
    secondary: { main: SECONDARY_MAIN },
  },
  typography: {
    fontFamily: "'Lato', 'Roboto', 'Helvetica', 'Arial', sans-serif",
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        ':focus-visible': {
          outline: '2px solid #5F5BCD',
          outlineOffset: '2px',
        },
        'a:focus-visible, button:focus-visible, [role="button"]:focus-visible, [role="tab"]:focus-visible, [tabindex="0"]:focus-visible': {
          outline: '2px solid #5F5BCD',
          outlineOffset: '2px',
          borderRadius: '2px',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          '&:focus-visible': { boxShadow: FOCUS_RING },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          '&:focus-visible': { boxShadow: FOCUS_RING },
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          '&:focus-visible': { boxShadow: 'inset 0 0 0 2px #5F5BCD' },
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          '&:focus-visible': {
            outline: '2px solid #5F5BCD',
            outlineOffset: '2px',
            borderRadius: '2px',
          },
        },
      },
    },
  },
});

export default theme;
